// 模拟机详情
export default {
    simulator: 'симулятор',
    initialPosition: 'начальная позиция',
    altitude: 'высота',
    startUp: 'запускать',
    remainingTime: 'оставшееся время',
    minute: 'минута ',
    offline: 'отключаться от',
    startSuccess: 'Успешно начато',
    stoppedSuccess: 'Успешно остановлен',
    mapPicking: 'Выбор карты',
    endPickup: 'Конечный пикап',
    tip_FEPI: 'Ошибка форматирования, повторите ввод',
    tip_PELng: 'введите долготу,Пожалуйста',
    tip_PELat: 'введите широту,Пожалуйста',
    tip_PEA: 'введите высоту, Пожалуйста',
    tip_PETA: 'Пожалуйста, введите адрес',
    tip_CFTA: "Не могу найти адрес",
    tip_EBWR: 'Пример: Западный вокзал Пекина, район Фэнтай, Пекин.',
}